import { render } from "./Viewchq.vue?vue&type=template&id=546dbc54&ts=true"
import script from "./Viewchq.vue?vue&type=script&lang=ts"
export * from "./Viewchq.vue?vue&type=script&lang=ts"

import "./Viewchq.vue?vue&type=style&index=0&id=546dbc54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__